import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/1/lb1.jpg'
import _imports_1 from '@/assets/image/1/lb2.jpg'
import _imports_2 from '@/assets/image/1/lb3-zy.jpg'
import _imports_3 from '@/assets/image/1/lb4-yyy.jpg'
import _imports_4 from '@/assets/image/1/lb5-slys.jpg'
import _imports_5 from '@/assets/image/1/1 关于我们 555×333px.jpg'
import _imports_6 from '@/assets/image/1/长箭头.png'
import _imports_7 from '@/assets/image/1/1 企业愿景 560×310px - 副本.png'
import _imports_8 from '@/assets/image/1/1 企业价值观 240×345px.jpg'
import _imports_9 from '@/assets/image/1/1 企业价值观2 240×345px.jpg'
import _imports_10 from '@/assets/image/1/1 企业价值观3 240×345px.jpg'
import _imports_11 from '@/assets/image/1/1 企业价值观4 240×345px.jpg'
import _imports_12 from '@/assets/image/1/1 企业价值观5 240×345px.jpg'
import _imports_13 from '@/assets/image/1/1 企业公众号 130×130px.jpg'
import _imports_14 from '@/assets/image/1/1 商务合作 130×130px.jpg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-4ed1abca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "banner" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1))
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"aboutUs container\" data-v-4ed1abca><div class=\"title animated animate-title\" data-v-4ed1abca><div class=\"en color-b2\" data-v-4ed1abca>ABOUTUS</div><div class=\"cn color-0243bb\" data-v-4ed1abca>关于我们</div></div><div class=\"content animated animated-content\" data-v-4ed1abca><div class=\"img\" data-v-4ed1abca><img src=\"" + _imports_5 + "\" data-v-4ed1abca></div><div class=\"right\" data-v-4ed1abca><div style=\"font-size:18px;\" data-v-4ed1abca>上海微卓医疗科技有限公司</div><div class=\"color-b2\" style=\"margin-bottom:30px;font-size:14px;\" data-v-4ed1abca> Shanghai Wei zhuo Medical Technology Co., Ltd. </div><div style=\"margin-bottom:26px;\" data-v-4ed1abca> 上海微卓医疗科技有限公司，成立于2020年，是一家集眼视光产品研发、代理及投资医疗实体的多元化创新公司。公司位于上海静安区核心CBD商圈，核心团队由眼视光领域医生及医疗管理团队组成。 </div><div style=\"margin-bottom:26px;\" data-v-4ed1abca> 2021年创建“MUEYECO” 品牌，SLOGAN“目之所及，皆为欢喜”，与眼睛相关的，所看到的，感受到的，都能带来愉悦欢喜。主要分为四个系列: 目爱可系列、禾目达系列、沐悦明系列、星目明系列。 </div><div data-v-4ed1abca> 每年可服务数以万计的目标客户， 在全国有众多代理商， 有自己的电商渠道和专 业的服务团队，产品在多个平台均有销售。 </div></div></div></div>", 1)
const _hoisted_9 = { class: "products container" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title animated animate-title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "en color-b2" }, "PRODUCTS"),
  /*#__PURE__*/_createElementVNode("div", { class: "cn color-0243bb" }, "主要产品")
], -1))
const _hoisted_11 = { class: "content animated animated-content" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "text" }
const _hoisted_15 = { style: {"font-size":"16px"} }
const _hoisted_16 = { style: {"color":"#868686","margin-bottom":"32px"} }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detail-box" }, [
  /*#__PURE__*/_createTextVNode(" 了解详情 "),
  /*#__PURE__*/_createElementVNode("img", {
    style: {"width":"30px","margin-left":"146px"},
    src: _imports_6
  })
], -1))
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<div class=\"vision container\" data-v-4ed1abca><div class=\"title animated animate-title\" data-v-4ed1abca><div class=\"en color-b2\" data-v-4ed1abca>VISION</div><div class=\"cn color-0243bb\" data-v-4ed1abca>企业愿景</div></div><div class=\"content animated animated-content\" data-v-4ed1abca><div class=\"right\" data-v-4ed1abca><div style=\"margin-bottom:26px;font-size:16px;\" data-v-4ed1abca> 以<span style=\"color:#0243bb;\" data-v-4ed1abca>“积微成卓”</span>为经营理念，力争将产品从实用性、功能性、有效性、以及服务品质上让客户交口称誉。 </div><div style=\"margin-bottom:26px;\" data-v-4ed1abca> 为眼视光行业内提供产品及服务输出，力争达到专业性、标准化、精简性的使用价值，成为眼视光行业及门诊终端的风向标及引跑者。 </div></div><div class=\"img\" data-v-4ed1abca><img src=\"" + _imports_7 + "\" data-v-4ed1abca></div></div></div><div class=\"value container\" data-v-4ed1abca><div class=\"title animated animate-title\" data-v-4ed1abca><div class=\"en color-b2\" data-v-4ed1abca>VALUE</div><div class=\"cn color-0243bb\" data-v-4ed1abca>企业价值观</div></div><div class=\"content animated animated-content\" data-v-4ed1abca><div class=\"img\" data-v-4ed1abca><div class=\"text\" style=\"background-image:linear-gradient(\r\n                -90deg,\r\n                rgb(161, 196, 253) 0%,\r\n                rgb(194, 233, 251) 100%\r\n              );\" data-v-4ed1abca> 诚信 </div><img src=\"" + _imports_8 + "\" data-v-4ed1abca></div><div class=\"img\" data-v-4ed1abca><img src=\"" + _imports_9 + "\" data-v-4ed1abca><div class=\"text\" style=\"background-image:linear-gradient(\r\n                -90deg,\r\n                rgba(111, 210, 218, 0.99608) 0%,\r\n                rgb(110, 207, 214) 0%,\r\n                rgb(125, 229, 237) 100%\r\n              );\" data-v-4ed1abca> 担当 </div></div><div class=\"img\" data-v-4ed1abca><div class=\"text\" style=\"background-image:linear-gradient(\r\n                0deg,\r\n                rgb(99, 163, 255) 0%,\r\n                rgb(182, 220, 255) 0%,\r\n                rgb(114, 190, 255) 100%\r\n              );\" data-v-4ed1abca> 进取 </div><img src=\"" + _imports_10 + "\" data-v-4ed1abca></div><div class=\"img\" data-v-4ed1abca><img src=\"" + _imports_11 + "\" data-v-4ed1abca><div class=\"text\" style=\"background-image:linear-gradient(\r\n                -90deg,\r\n                rgba(251, 180, 193, 0.99608) 0%,\r\n                rgb(238, 165, 178) 0%,\r\n                rgb(255, 182, 173) 100%\r\n              );\" data-v-4ed1abca> 协同 </div></div><div class=\"img\" data-v-4ed1abca><div class=\"text\" style=\"background-image:linear-gradient(\r\n                -90deg,\r\n                rgb(150, 139, 233) 0%,\r\n                rgb(142, 129, 225) 100%\r\n              );\" data-v-4ed1abca> 创新 </div><img src=\"" + _imports_12 + "\" data-v-4ed1abca></div></div></div><div class=\"connection container\" data-v-4ed1abca><div class=\"title animated animate-title\" data-v-4ed1abca><div class=\"en color-b2\" data-v-4ed1abca>CONNECTION</div><div class=\"cn color-0243bb\" data-v-4ed1abca>联系我们</div></div><div class=\"content animated animated-content\" data-v-4ed1abca><div class=\"left\" data-v-4ed1abca><div data-v-4ed1abca>电话：021-6333-1223 手机：13916102865</div><div data-v-4ed1abca>公司地址：上海市静安区江宁路212号10层 C1001、B1011室</div><div data-v-4ed1abca>公司邮箱：dingdan@youmujia305.com.cn</div></div><div class=\"right\" data-v-4ed1abca><div data-v-4ed1abca><img src=\"" + _imports_13 + "\" data-v-4ed1abca><p data-v-4ed1abca>企业公众号</p></div><div data-v-4ed1abca><img src=\"" + _imports_14 + "\" data-v-4ed1abca><p data-v-4ed1abca>商务合作</p></div></div></div></div>", 3)

import { reactive, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";

import Wow from "wow.js";


export default /*#__PURE__*/_defineComponent({
  __name: 'home',
  setup(__props) {

let router = useRouter();

// 跳转产品页
function goProduct(e) {
  router.push({
    path: "/product",
    query: {
      type: e,
    },
  });
}

// 主要产品
let productMain = reactive([
  {
    img: require("@/assets/image/1/1 明星产品 385×280px.jpg"),
    title: "Mueyeco进口儿童鱼油",
    desc: "高DHA+蓝莓+叶黄素 一瓶抵三瓶营养",
    linkType: 0,
  },
  {
    img: require("@/assets/image/1/1 明星产品2 385×280px.jpg"),
    title: "沐悦明隐形眼镜润滑液",
    desc: "无防腐剂 长期使用无忧",
    linkType: 1,
  },

  {
    img: require("@/assets/image/1/1 明星产品3 385×280px.jpg"),
    title: "沐悦明接触镜无菌生理盐水",
    desc: "无防腐剂 长期使用无忧",
    linkType: 1,
  },

  {
    img: require("@/assets/image/1/1 明星产品4 385×280px.jpg"),
    title: "禾目达真空等离子仪",
    desc: "OK镜护理 等离子镀膜保湿 使用便捷",
    linkType: 2,
  },
  // {
  //   img: require("@/assets/image/1/1 明星产品5 385×280px.jpg"),
  //   title: "星月明一次性遮阳镜",
  //   desc: "术后遮瑕 散瞳遮光",
  // },
  {
    img: require("@/assets/image/1/藻油385x280px.jpg"),
    title: "Mueyeco澳洲进口藏红花酸儿童藻油",
    desc: "藏红花+DHA+叶黄素等独特配方 科学配比",
    linkType: 0,
  },
  {
    img: require("@/assets/image/1/1 明星产品6 385×280px.jpg"),
    title: "禾目达眼科门诊电子软件系统",
    desc: "自主研发 高效稳定 方便快捷",
    linkType: 2,
  },
]);

onMounted(() => {
  // 标题动画
  const wow = new Wow({
    // 对所有拥有该class的元素挂载动画
    boxClass: "animate-title",
    // 需要挂载的动画元素
    animateClass: "animate__lightSpeedInLeft",
    // 偏移值（即偏移一定距离后再执行动画，推荐设置！）
    offset: 80,
    // 移动设备是否生效
    mobile: true,
    // 是否支持异步
    live: true,
  });
  wow.init();

  // 内容动画
  const wow2 = new Wow({
    // 对所有拥有该class的元素挂载动画
    boxClass: "animated-content",
    // 需要挂载的动画元素
    animateClass: "animate__fadeInUp",
    // 偏移值（即偏移一定距离后再执行动画，推荐设置！）
    offset: 80,
    // 移动设备是否生效
    mobile: true,
    // 是否支持异步
    live: true,
  });
  wow2.init();
});

return (_ctx: any,_cache: any) => {
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_carousel, {
        height: "700px",
        autoplay: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_carousel_item, null, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode(_component_el_carousel_item, null, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }),
          _createVNode(_component_el_carousel_item, null, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }),
          _createVNode(_component_el_carousel_item, null, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }),
          _createVNode(_component_el_carousel_item, null, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _hoisted_8,
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(productMain), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "img",
            onClick: ($event: any) => (goProduct(item.linkType)),
            key: index
          }, [
            _createElementVNode("img", {
              src: item.img
            }, null, 8, _hoisted_13),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, _toDisplayString(item.title), 1),
              _createElementVNode("div", _hoisted_16, _toDisplayString(item.desc), 1),
              _hoisted_17
            ])
          ], 8, _hoisted_12))
        }), 128))
      ])
    ]),
    _hoisted_18
  ]))
}
}

})